"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearDataDefaults = clearDataDefaults;
const checkType_1 = __importDefault(require("./checkType"));
const IOptions_1 = require("../WrappedProperty/IOptions");
/**
 * zwraca wyczyszczone dane, tylko te które są zgodne ze schematem
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {*} data dane wejściowe
 * @param {boolean} [checkDataType] czy sprawdzac poprawnośc typów danych prostych
 * (number,integer,boolean, string), domyślnie nie
 * @param {IOptions} [options] opcje, zawierające np. informacje o wyłączonych polach
 * @param {string} [currentPath=''] bieżąca ścieżka
 * @returns {*} wyczyszczone dane
 */
function clearDataDefaults(schema, data, checkDataType, options = IOptions_1.defaultOptions, currentPath = '') {
    if (schema.computed) {
        return undefined;
    }
    if (schema.disabled) {
        if (schema.disabled === true || (options && options._disabledFields && options._disabledFields.has(currentPath))) {
            return undefined;
        }
    }
    if (schema.type === 'object') {
        if (typeof data !== 'object') {
            return undefined;
        }
        if (data === null) {
            return undefined;
        }
        const result = {};
        let anyProp = false;
        const props = schema.properties;
        if (props) {
            const path = currentPath === '' ? currentPath : currentPath + '.';
            for (const key in props) {
                const value = data[key];
                const element = props[key];
                if (value !== undefined) {
                    const nvalue = clearDataDefaults(element, value, checkDataType, options, path + key);
                    if (nvalue !== undefined) {
                        result[key] = nvalue;
                        anyProp = true;
                    }
                }
            }
        }
        return anyProp ? result : undefined;
    }
    else if (schema.type === 'array') {
        if (Array.isArray(data)) {
            const result = [];
            const items = schema.items;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < data.length; i++) {
                const nvalue = clearDataDefaults(items, data[i], checkDataType, options, currentPath + '[' + i + ']');
                if (nvalue !== undefined) {
                    result.push(nvalue);
                }
            }
            if (result.length == 0)
                return undefined;
            return result;
        }
        else {
            return undefined;
        }
    }
    else {
        // na razie nie sprawdzamy typów danych
        if (Array.isArray(data)) {
            return undefined;
        }
        if (typeof data === 'object') {
            return undefined;
        }
        if (data === null)
            return undefined;
        if (checkDataType && !(0, checkType_1.default)(schema, data)) {
            return undefined;
        }
        switch (schema.type) {
            case 'boolean':
                if (data === false)
                    return undefined;
                break;
            case 'string':
                if (data === '')
                    return undefined;
                break;
            case 'integer':
            case 'number':
            case 'money':
                // if (data === 0)
                //   return undefined;
                break;
        }
        return data;
    }
}
exports.default = clearDataDefaults;
//# sourceMappingURL=clearDataDefaults.js.map